import { requests } from ".";

/**
 * @description Brand Board related API calls
 */
export const BrandBoardServices = {
  /**
   * @description Get all custom colors for a location's brand board
   * @param locationId string - Location ID
   */
  getCustomColors: (locationId: string) =>
    requests().get(`/brand-boards/custom-colors/${locationId}/all`),

  /**
   * @description Get default brand colors for a location's brand board
   * @param locationId string - Location ID
   */
  getBrandColor: (locationId: string) => requests().get(`/brand-boards/${locationId}/default`),

  /**
   * @description Fire-and-forget brand-boards usage/analytics event.
   * @param locationId string - Location ID
   * @param body { eventName, properties } - allow-listed event + properties
   */
  trackActivity: (
    locationId: string,
    body: { eventName: string; properties: Record<string, unknown> }
  ) =>
    requests().post(`/brand-boards/locations/${locationId}/activity`, body, {
      headers: { "x-source-app": "form-survey-builder" },
    }),
};

export interface BrandBoardColorResponse {
  customColors?: Array<{
    key: string;
    name: string;
    value: string;
  }>;
}

export interface StoreCustomColor {
  alpha: number;
  value: string;
  value8: string;
  label: string;
  custom: string;
  inputType: "Custom";
}
